<template>
  <el-card>

    <el-form inline :model="query" class="filter-form">
      <el-form-item label="手机号">
        <el-input v-model.trim="query.phoneNumber" placeholder="请输入" style="width: 300px" />
      </el-form-item>
      <el-form-item label="场景值">
        <el-input v-model.trim="query.scene" placeholder="请输入" style="width: 300px" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="queryCollection">查询</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="showDialog">导出用户信息</el-button>
      </el-form-item>
    </el-form>
    <el-table class="table block" :header-cell-style="tableHeaderStyle" v-loading="loading" :data="collection">
      <el-table-column align="center" prop="id" label="序号" />
      <el-table-column align="center" prop="nickName" label="会员昵称" />
      <el-table-column align="center" prop="phoneNumber" label="会员手机号" />
      <el-table-column align="center" prop="birthday" label="会员生日" />
      <el-table-column align="center" label="会员地区">
        <template slot-scope="scope">
          {{scope.row.province}}
          {{scope.row.city}}
          {{scope.row.county}}
        </template>
      </el-table-column>
      <el-table-column align="center" prop="createdAt" label="注册时间" />
      <el-table-column align="center" prop="scene" label="注册场景">
        <template slot-scope="scope">
          {{scope.row.scene ? scope.row.scene:"-"}}
        </template>
      </el-table-column>
      <!--<el-table-column align="center" label="操作">-->
      <!--<template slot-scope="scope">-->
      <!--<router-link :to="{ name: 'banner-edit', query: { id: scope.row.id }}">-->
      <!--<el-button type="text" style="margin-right: 10px">编辑</el-button>-->
      <!--</router-link>-->
      <!--<el-button type="text" @click="remove(scope.row)">删除</el-button>-->
      <!--</template>-->
      <!--</el-table-column>-->
    </el-table>
    <pagination :total="total" :pagination="pagination" :changed="queryCollection" />

    <!--开始选择导出时间段-->
    <el-dialog title="请选择注册时间" :visible.sync="dialogFormVisible">
      <el-form :model="form" ref="form">
        <el-form-item label="开始时间" prop="startTime">
          <el-date-picker type="date" placeholder="开始时间" v-model="form.startTime" style="width: 100%;"></el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间" prop="endTime">
          <el-date-picker type="date" placeholder="结束时间" v-model="form.endTime" style="width: 100%;"></el-date-picker>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="exportWarranty">确 定</el-button>
      </div>
    </el-dialog>
    <!--导出时间段结束-->
  </el-card>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex'

  const { mapGetters } = createNamespacedHelpers('users')

  export default {
    data() {
      return {
        loading: false,
        query: {
          phoneNumber: undefined,
          scene:undefined
        },
        form: {
          startTime: '',
          endTime: '',
        },
        dialogFormVisible: false,
      }
    },
    components: {
    },
    computed: {
      ...mapGetters(['collection', 'total', 'pagination']), // 映射必要数据
    },
    methods: {
      async queryCollection({ pagination = {limit: 10} } = {}) {
        const query = {
          ...this.query,
        }
        try {
          this.loading = true
          await this.$store.dispatch('users/collection', { query, pagination })
        } finally {
          this.loading = false
        }
      },
      tableHeaderStyle(){
        return 'color:#000;font-wight:500;font-size:16px;height:60px;background-color:#e6e9f2;'
      },
      showDialog() {
        this.dialogFormVisible = true
      },
      async exportWarranty() {
        await this.$formHelper.promisedValidate(this.$refs.form)
        let query = {start : this.form.startTime, end : this.form.endTime}

        query.start = new Date(Date.parse(query.start) + 8 * 3600 * 1000)
        query.start = query.start.toJSON().substr(0, 19).replace('T', ' ')

        query.end = new Date(Date.parse(query.end) + 8 * 3600 * 1000)
        query.end = query.end.toJSON().substr(0, 19).replace('T', ' ')
        this.$linkHelper.redirect('user-export', query)
      }
    },
    mounted() {
      this.queryCollection()
    },
    activated() {
      this.queryCollection()
    }
  }
</script>
